module.exports = __webpack_public_path__ + "static/media/service19.baa79964.jpg";